export default{
    'MESSAGE_NOPE': 'MESSAGE_NOPE',
    '_UI_STATE_CHANGED': '_UI_STATE_CHANGED',
    '_LOGIN_STATE_CHANGED': '_LOGIN_STATE_CHANGED',    
    //
    'MESSAGE_DUMMY_EVENT': 'MESSAGE_DUMMY_EVENT'
};